import React from 'react';
import PropTypes from 'prop-types';

import CustomTable from '../customTable';

const RowHeaders = {
  percentile90thAverageAnnualSalary: '90th Percentile',
  percentile75thAverageAnnualSalary: '75th Percentile',
  nationalAverageAnnualSalary: 'Average',
  percentile25thAverageAnnualSalary: '25th Percentile',
  percentile10thAverageAnnualSalary: '10th Percentile',
};

const columnsConfig = {
  percentile: {
    columnName: 'Percentile',
  },
  annualSalary: {
    columnName: 'Annual Salary',
    customSortByField: 'annualSalaryNum',
  },
  monthlySalary: {
    columnName: 'Monthly Salary',
    customSortByField: 'monthlySalaryNum',
  },
  hourlyRate: {
    columnName: 'Hourly Rate',
    customSortByField: 'hourlyRateNum',
  },
};

const SalaryPercentileTable = ({ customClass, percentiles, title }) => {
  const tableData = percentiles.map(({ key, ...rest }) => ({
    percentile: RowHeaders[key],
    ...rest,
  }));
  return (
    tableData.length > 0 && (
      <div className={customClass}>
        <CustomTable
          columnConfig={columnsConfig}
          bodyData={tableData}
          tableHeaderTitleContent={
            title ? <h3 className="zp-title-h3 text-capitalize z-mb-24">{title}</h3> : null
          }
        />
      </div>
    )
  );
};

SalaryPercentileTable.propTypes = {
  customClass: PropTypes.string,
  percentiles: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      annualSalary: PropTypes.string,
      monthlySalary: PropTypes.string,
      hourlyRate: PropTypes.string,
    })
  ).isRequired,
};

SalaryPercentileTable.defaultProps = {
  customClass: null,
};

export default SalaryPercentileTable;
